import { addDaysToISODate, isoDateOnly } from './recSchedulingDates';

/** Days 56-60 of an episode, counted from its start (offsets 55 and 59). */
const RECERT_WINDOW_FIRST_OFFSET = 55;
const RECERT_WINDOW_LAST_OFFSET = 59;

export function isRecertVisitType(
  visitType: string | null | undefined
): boolean {
  return !!visitType && visitType.startsWith('OASIS_E2_RECERTIFICATION');
}

/**
 * The days a Recert may be scheduled on: days 56-60 of the episode, cut to its
 * end date. Null when the episode ends before day 56 or a date is missing.
 * Mirrors `recertification_window` on the backend, which refuses other days.
 */
export function recertWindow(
  episodeStart: string | null | undefined,
  episodeEnd: string | null | undefined
): { start: string; end: string } | null {
  const start = addDaysToISODate(episodeStart, RECERT_WINDOW_FIRST_OFFSET);
  const lastDay = addDaysToISODate(episodeStart, RECERT_WINDOW_LAST_OFFSET);
  const end = isoDateOnly(episodeEnd);
  if (!start || !lastDay || !end) return null;
  const windowEnd = end < lastDay ? end : lastDay;
  return start <= windowEnd ? { start, end: windowEnd } : null;
}
